<template>
  <v-form v-model="isAccountFormValid" ref="form">
    <v-text-field
      label="First Name"
      v-bind="inputAttrs"
      :value="authUser.first_name"
      @input="updateUserEntity({ first_name: $event })"
      :rules="[ValidationRules.requiredString]"
    />

    <v-text-field
      label="Last Name"
      v-bind="inputAttrs"
      :value="authUser.last_name"
      @input="updateUserEntity({ last_name: $event })"
      :rules="[ValidationRules.requiredString]"
    />
    <v-text-field
      label="Phone"
      v-bind="inputAttrs"
      :value="authUser.phone"
      @input="updateUserEntity({ phone: $event })"
      :rules="[ValidationRules.requiredString, ValidationRules.phoneRule]"
    />
    <v-text-field
      label="Email"
      v-bind="inputAttrs"
      :value="authUser.email"
      @input="updateUserEntity({ email: $event })"
      :rules="[ValidationRules.requiredString, ValidationRules.emailRule]"
    />
    <template v-if="getShouldCapturePaymentInfo">
      <v-select
        v-model="authUser.payment_service"
        :items="['Venmo', 'CashApp', 'Paypal']"
        color="deep-orange"
        label="Payment Service"
        @input="updateUserEntity({ payment_service: $event })"
        large
      />
      <v-text-field
        label="Payment Handle"
        v-bind="inputAttrs"
        :value="authUser.payment_handle"
        @input="updateUserEntity({ payment_handle: $event })"
      />
    </template>

    <v-text-field
      label="Street Address"
      v-bind="inputAttrs"
      :value="authUser.street"
      @input="updateUserEntity({ street: $event })"
    />
    <v-text-field
      label="Zipcode"
      v-bind="inputAttrs"
      :value="authUser.zip"
      @input="updateUserEntity({ zip: $event })"
      :rules="[zipWithStreetOnlyRule]"
    />

    <v-btn
      @click="persistUserData"
      :loading="saving"
      depressed
      :disabled="!isAccountFormValid || saving || !modifiedFieldNames.length"
      class="d-inline"
      color="blue darken-2 white--text"
      >Save</v-btn
    >
    <v-btn
      @click="reset"
      depressed
      :disabled="saving || !modifiedFieldNames.length"
      class="d-inline ml-2"
      outlined
      color="blue darken-2 white--text"
      >Cancel Changes</v-btn
    >
  </v-form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import ValidationRules from '@/constants/ValidationRules'

import _get from 'lodash/get'

export default {
  name: 'CustomerEditForm',
  components: {},
  data() {
    return {
      saving: false,
      error: false,
      isAccountFormValid: false,
      originalUser: {},
      ValidationRules,
      inputAttrs: {},
      fields: [
        { name: 'first_name' },
        { name: 'last_name' },
        { name: 'phone' },
        { name: 'email' },
        { name: 'payment_handle' },
        { name: 'payment_service' },
        { name: 'street' },
        { name: 'zip' },
      ],
    }
  },

  created() {
    if (!this.isCustomer) return

    this.originalUser = this.authUser
  },
  methods: {
    ...mapActions('auth', ['updateCustomerUser']),
    reset() {
      this.authUser = this.originalUser
    },
    updateUserEntity(changes) {
      this.authUser = { ...this.authUser, ...changes }
    }, // updateUserEntity
    async persistUserData() {
      let changes = {}

      this.modifiedFieldNames.forEach((fieldName) => {
        changes[fieldName] = this.authUser[fieldName]
      })
      await this.updateCustomerUser(changes)
      this.originalUser = await this.authUser
    }, // persistUserData
    _get,
  },
  computed: {
    ...mapGetters('auth', ['getAuthUser', 'isCustomer']),
    ...mapGetters('shop', ['getShouldCapturePaymentInfo']),
    ...mapFields('auth', { authUser: 'user' }),
    modifiedFieldNames() {
      // let isAddressModified =
      return this.fields
        .filter(
          (field) => this.authUser[field.name] !== this.originalUser[field.name]
        )
        .map((f) => f.name)
    }, // modifiedFieldNames
    zipWithStreetOnlyRule() {
      // Only require if street or zip is entered
      if (!!this.authUser.street || !!this.authUser.zip) {
        return ValidationRules.zipRule
      }
      return () => true
    },
  },
  watch: {
    'authUser.street': {
      handler() {
        this.$nextTick(() => this.$refs.form.validate())
      },
    },
  },
}
</script>

<style lang="css">
.user-edit input {
  font-size: 1.5em;
  line-height: 1.5;
  max-height: none;
}
</style>
